import type { ReactElement } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface LoadingPieProps {
  baseContainerClasses: string;
  className?: string;
}

export const LoadingPie = ({
  className,
  baseContainerClasses,
}: LoadingPieProps): ReactElement => (
  <div className={classNames(baseContainerClasses, "gap-4", className)}>
    <div className="bg-tertiary h-6 w-1/2 animate-pulse rounded-full" />
    <div className="flex flex-col items-center gap-4">
      <div className="bg-tertiary size-60 animate-pulse rounded-full" />
      <div className="flex flex-wrap justify-center gap-4">
        {Array.from({ length: 4 }, (_, index) => (
          <div key={`pie-legend-${index}`} className="flex items-center gap-2">
            <div className="bg-tertiary size-3 animate-pulse rounded-full" />
            <div className="bg-tertiary h-4 w-16 animate-pulse rounded-full" />
          </div>
        ))}
      </div>
    </div>
  </div>
);
